export var IdInputLimits;
(function (IdInputLimits) {
    IdInputLimits[IdInputLimits["CharLimitFeedback"] = 1200] = "CharLimitFeedback";
})(IdInputLimits || (IdInputLimits = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdInputLimits.ts
// module id = 2832
// module chunks = 3